import { createElement as h } from "react";
import { ArrowRight } from "lucide-react";
import { blogCoverAttributes } from "../../utils/siteSeo.mjs";

// Homepage placement is editorial, never inferred from publication date or tags.
export function selectHomeHighlights(posts) {
  if (!Array.isArray(posts)) return [];
  return posts.filter((post) => (
    post && Number.isInteger(post.homeFeature?.order) && post.homeFeature.order >= 0
    && typeof post.title === "string" && post.title.trim()
    && typeof post.slug === "string" && /^[a-z0-9-]+$/.test(post.slug)
    && typeof post.cover === "string" && post.cover.startsWith("/content/blog/")
  )).sort((a, b) => a.homeFeature.order - b.homeFeature.order || a.slug.localeCompare(b.slug));
}

function publicationDate(value) {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(`${value}T00:00:00Z`);
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value) return null;
  return h("time", { dateTime: value }, new Intl.DateTimeFormat("en-US", {
    month: "short", day: "numeric", year: "numeric", timeZone: "UTC",
  }).format(date));
}

export default function HomeHighlightsContent({ posts }) {
  const highlights = selectHomeHighlights(posts);
  if (!highlights.length) return null;

  return h("section", { className: "home-highlights", "aria-labelledby": "home-highlights-title" },
    h("div", { className: "home-highlights-heading" },
      h("h2", { id: "home-highlights-title" }, "News & highlights"),
      h("a", { className: "home-highlights-all", href: "/blog" }, "All stories", h(ArrowRight, { size: 17, "aria-hidden": true })),
    ),
    ...highlights.map((post) => h("article", { className: "home-highlight", key: post.slug },
      h("a", { className: "home-highlight-image", href: `/blog/${post.slug}`, tabIndex: -1, "aria-hidden": true },
        h("img", { ...blogCoverAttributes(post, "(max-width: 760px) calc(100vw - 32px), (max-width: 1240px) 46vw, 560px"), alt: "", loading: "lazy", decoding: "async" }),
      ),
      h("div", { className: "home-highlight-copy" },
        h("div", { className: "home-highlight-meta" },
          h("span", { className: "home-highlight-label" }, post.homeFeature.label || "Featured story"),
          publicationDate(post.date),
        ),
        h("h3", null, h("a", { href: `/blog/${post.slug}` }, post.title)),
        post.subtitle ? h("p", null, post.subtitle) : null,
        h("a", { className: "home-highlight-read", href: `/blog/${post.slug}`, "aria-label": `Read story: ${post.title}` },
          "Read story", h(ArrowRight, { size: 19, "aria-hidden": true }),
        ),
      ),
    )),
  );
}
